<template>
  <div>
    <h4>Debug vars</h4>
    <div class="list-group">
      <div class="list-group-item list-group-item-action" v-for="(d, i) in DebugVariables" :key="i">
        <div class="d-flex w-100 justify-content-between">
          <h5 class="mb-1">{{d.Key}}</h5>
          <small>{{i}}</small>
        </div>
        <pre class="mb-1">{{d.Value}}</pre>
        <small>{{d.Meta}}</small>
      </div>
    </div>
  </div>
</template>

<script>
import * as clinkVars from "@/api/entrypoints";
import * as D from "@/utility/DebugConfig";

export default {
  name: "ShowDebugVariables",
  data: function() {
    return {
      DebugVariables: [
        {
          Key: "CLink Entry Point",
          Value: JSON.stringify(clinkVars, null, 2),
          Meta: "clinkVars"
        },
        {
          Key: "WindowLocation",
          Value: JSON.stringify(window.location, null, 2),
          Meta: "JSON.stringify(window.location, null, 2)"
        },
        {
          Key: "Debug Config",
          Value: JSON.stringify(D, null, 2),
          Meta: "JSON.stringify(D, null, 2)"
        },
        {
          Key: "Env",
          Value: process.env,
          Meta: "process.env"
        }
      ]
    };
  }
};
</script>

<style scoped>
</style>
